import React, { useState, useEffect } from 'react';
import { Cell, Grid } from 'react-md'
import { createVideoLinkIframe, replaceImageWidth } from '../../../../../common/functions';
import MathJax, { getImageAccessibilityText } from '../../../../../components/react-mathjax-preview';
import LoadingSpinner from '../../../../../components/LoadingSpinner';
import MathParserUtil from '../../../../../lib/math-parser';
import { Checkbox } from '@mui/material';
import SFVectorAnswer from "./SFVectorAnswer"
import VectorParserUtil from '../../../../../lib/vector-math-parser'

const checkBoxOneColumnSize = 1;
const checkBoxValueOneColumnSize = 12;

const checkBoxTwoColumnSize = 1;
const checkBoxValueTwoColumnSize = 6;

const getVectorOptionDescription = (answerArr, optionIndex, isChecked, vectorSettingsData) => {
    let description = `Answer option ${optionIndex + 1}.`;
    
    if (isChecked) {
        description += ` Selected.`;
    } else {
        description += ` Not selected.`;
    }

    let vectors = answerArr?.newVectorValues;
    if ((!vectors || vectors.length === 0) && answerArr?.vectorAnswerVariable && vectorSettingsData) {
        try {
            const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerArr?.vectorAnswerVariable);
            if (vectorVariableMap) {
                vectors = vectorVariableMap.getVectorsArray(
                    vectorSettingsData?.enableIdenticalVector,
                    vectorSettingsData
                ).filter(value => value !== undefined);
            }
        } catch (e) {
            console.error("Error parsing vectors for description:", e);
        }
    }

    if (vectors && vectors.length > 0) {
        description += ` Graph containing ${vectors.length} vector${vectors.length > 1 ? 's' : ''}:`;
        vectors.forEach((vector, idx) => {
            let vecName = vector.name || `vector ${idx + 1}`;
            if (vecName.includes("\\vec{")) {
                vecName = vecName.replace(/\\vec{([^}]+)}/, "$1");
            }
            
            description += ` ${vecName}`;
            if (vector.inputType === "angle-magnitude" || (vector.mag !== undefined && vector.angle !== undefined)) {
                description += ` with magnitude ${vector.mag} and angle ${vector.angle} degrees`;
            } else if (vector.x !== undefined && vector.y !== undefined) {
                description += ` pointing with components x = ${vector.x}, y = ${vector.y}`;
            }
            if (vector.posX !== undefined && vector.posY !== undefined) {
                description += ` starting at coordinates (${vector.posX}, ${vector.posY})`;
            }
            description += `.`;
        });
    } else if (answerArr.answer_text) {
        let plainText = answerArr.answer_text;
        if (plainText.includes("<img")) {
            plainText = getImageAccessibilityText(plainText) || 'Image option.';
        } else {
            plainText = plainText.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        }
        description += ` ${plainText}`;
    }
    return description;
};

const SFMCChecboxTypeAnswers = function (props) {

    let correctAnswerIds = [];

    const [localValueArr, setLocalValueArr] = useState([]);

    useEffect(() => {
        if (props.selectedAnswerArray) {
            console.debug("props.selectedAnswerArray>>>>", props.selectedAnswerArray)
            setLocalValueArr(props.selectedAnswerArray)
        }
    }, [props.selectedAnswerArray])

    let handleClick = function (id, index) {
        if (props.onAnswerChoice !== undefined)
            props.onAnswerChoice(id, index);


    }

    const removeElementFromArray = (arr, element) => {
        var i = arr.indexOf(element);
        if (i !== -1) {
            arr.splice(i, 1);
        }
        ////console.log("questionIds Array value =",arr);
        return arr;
    }

    let handleClickContent = function (index) {
        let checkboxElement = document.getElementById('checkBox' + index);
        if (checkboxElement !== undefined && checkboxElement !== null)
            checkboxElement.click();
    }


    let checkBoxSizeDesktop;
    let checkBoxValueSizeDesktop;

    if (props.numOfColumns === 2) {
        checkBoxSizeDesktop = checkBoxTwoColumnSize;
        checkBoxValueSizeDesktop = checkBoxValueTwoColumnSize;
    } else {
        checkBoxSizeDesktop = checkBoxOneColumnSize;
        checkBoxValueSizeDesktop = checkBoxValueOneColumnSize;
    }

    let answerDisplayArray = [];
    var tempSelectedAnswerArray = props.selectedAnswerArray;

    if (props.displayAnswerArr !== undefined && props.displayAnswerArr !== null && props.displayAnswerArr !== "" ) {
        answerDisplayArray = props.displayAnswerArr.map((answerArr, cIndex) => {
            if (answerArr.answer_text !== undefined && answerArr.answer_text !== null && answerArr.answer_text !== "" && props?.currentAnswerType !== 80) {
                var checkBox = <Checkbox
                    id={'checkBox' + cIndex}
                    /* onClick={(e) => {
                        e.preventDefault();
                        handleClick(answerArr.answer_id.toString(), cIndex)
                    }} */
                    type='checkbox'
                    size='small'
                    className='p-0 mr-2'
                    // hidden={!props.compact}
                    // hidden
                    value={answerArr.answer_id.toString()}
                    checked={localValueArr.includes(answerArr.answer_id.toString())} />;
                if (answerArr.isChecked === true || localValueArr.includes(answerArr.answer_id.toString())) {
                    checkBox = <Checkbox
                        id={'checkBox' + cIndex}
                        /* onClick={(e) => {
                            e.preventDefault();
                            handleClick(answerArr.answer_id.toString(), cIndex)
                        }} */
                        checked 
                        size='small'
                        className='p-0 mr-2'
                        // hidden={!props.compact}
                        // hidden
                        type='checkbox'
                        value={answerArr.answer_id.toString()} />
                }
                var ansTxt = answerArr.answer_text.toString('html', null).replace("<p><br></p>", "").replace("<p><br></p>", "")
                if (props.currentQuestionType === 1) {
                    ansTxt = MathParserUtil.computeFormula(ansTxt, props.currentVariableMap, answerArr.answer_display_options);
                }
                if (props.currentQuestionType === 3 && props.answerType === 60) {
                    ansTxt = MathParserUtil.computeFormula(ansTxt, props.currentVectorVariableMap, answerArr.answer_display_options);
                }
                ansTxt = replaceImageWidth(props, ansTxt)


                let content = React.createElement(MathJax, { "math": ansTxt, hideImagesFromScreenReader: true });

                return (
                    <Cell key={cIndex + 'CheckBox'}
                        className={`w-full h-full cursor-pointer ${props.compact ? 'sf-ans-btn-parent' : ''}`}
                        size={checkBoxValueSizeDesktop} >
                        <div
                            tabIndex={0}
                            aria-label={getVectorOptionDescription(answerArr, cIndex, localValueArr.includes(answerArr.answer_id.toString()), props?.vectorSettingsData)}
                            onKeyDown={(e) => {
                                if (e.key === ' ' || e.key === 'Enter') {
                                    e.preventDefault();
                                    let newLocalValueArr = [...localValueArr];
                                    if (newLocalValueArr.includes(answerArr.answer_id.toString())) {
                                        newLocalValueArr = removeElementFromArray(newLocalValueArr, answerArr.answer_id.toString());
                                    } else {
                                        newLocalValueArr.push(answerArr.answer_id.toString());
                                    }
                                    setLocalValueArr(newLocalValueArr);
                                    handleClick(answerArr.answer_id.toString(), cIndex);
                                }
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                let newLocalValueArr = [...localValueArr];
                                if (newLocalValueArr.includes(answerArr.answer_id.toString())) {
                                    newLocalValueArr = removeElementFromArray(newLocalValueArr, answerArr.answer_id.toString());
                                } else {
                                    newLocalValueArr.push(answerArr.answer_id.toString());
                                }
                                console.debug("newLocalValueArr>>>", newLocalValueArr)
                                setLocalValueArr(newLocalValueArr)
                                handleClick(answerArr.answer_id.toString(), cIndex)
                            }}
                            key={cIndex}
                            className={`
                                sf-ans-btn d-flex justify-content-center align-items-center cursor-pointer
                                ${localValueArr.includes(answerArr.answer_id.toString()) ? "sf-ans-btn-selected " : " "}
    
                                ${props.showAnswerResponse && !props.showSubmitLoader && (tempSelectedAnswerArray !== undefined &&
                                    tempSelectedAnswerArray.includes(answerArr.answer_id.toString())) ? (props.answerCorrect ? "sf-ans-btn-correct " : "sf-ans-btn-incorrect ") : " "}
    
                                ${props.showAnswerResponse && !props.showSubmitLoader && answerArr.isChecked ? "sf-ans-btn-correct " : " "}
                            `}
                        >
                            {checkBox}
                            <label for={'checkBox' + cIndex} className='w-100 cursor-pointer p-0 m-0'>{content}{ansTxt !== null ? createVideoLinkIframe(ansTxt) : ''}</label>
                        </div>

                    </Cell>
                );
            } else if(props.currentQuestionType === 0 && answerArr?.vectorAnswerVariable && answerArr?.vectorAnswerVariable.length > 0 && props?.currentAnswerType === 80 ) {
                var checkBox = <Checkbox
                id={'checkBox' + cIndex}
                // onClick={() => handleClick(answerArr.answer_id.toString(), cIndex)}
                type='checkbox'
                // hidden
                value={answerArr.answer_id.toString()}
                checked={localValueArr.includes(answerArr.answer_id.toString())} />;
                if (answerArr.isChecked === true) {
                    checkBox = <Checkbox
                        id={'checkBox' + cIndex}
                        // onClick={() => handleClick(answerArr.answer_id.toString(), cIndex)}
                        checked 
                        // hidden
                        type='checkbox'
                        value={answerArr.answer_id.toString()} />
                }

                const vectorSettingsData = props?.vectorSettingsData;
                return (
                    <Cell key={cIndex + 'CheckBox'}
                        className='w-full h-full cursor-pointer'
                        size={checkBoxValueSizeDesktop} >
                        <div
                            tabIndex={0}
                            aria-label={getVectorOptionDescription(answerArr, cIndex, localValueArr.includes(answerArr.answer_id.toString()), props?.vectorSettingsData)}
                            onKeyDown={(e) => {
                                if (e.key === ' ' || e.key === 'Enter') {
                                    if (e.target.closest(".view-vectors-container")) {
                                        return; // return if clicked within the '.view-vectors-container' 
                                    }
                                    e.preventDefault();
                                    let newLocalValueArr = [...localValueArr];
                                    if (newLocalValueArr.includes(answerArr.answer_id.toString())) {
                                        newLocalValueArr = removeElementFromArray(newLocalValueArr, answerArr.answer_id.toString());
                                    } else {
                                        newLocalValueArr.push(answerArr.answer_id.toString());
                                    }
                                    setLocalValueArr(newLocalValueArr);
                                    handleClick(answerArr.answer_id.toString(), cIndex);
                                }
                            }}
                            onClick={(e) => {
                                if (e.target.closest(".view-vectors-container")) {
                                    return; // return if clicked within the '.view-vectors-container' 
                                }
                                e.preventDefault();
                                let newLocalValueArr = [...localValueArr];
                                if (newLocalValueArr.includes(answerArr.answer_id.toString())) {
                                    newLocalValueArr = removeElementFromArray(newLocalValueArr, answerArr.answer_id.toString());
                                } else {
                                    newLocalValueArr.push(answerArr.answer_id.toString());
                                }
                                console.debug("newLocalValueArr>>>1", newLocalValueArr)
                                setLocalValueArr(newLocalValueArr)
                                handleClick(answerArr.answer_id.toString(), cIndex)
                            }}
                            key={cIndex}
                            className={`
                                sf-ans-btn d-flex justify-content-center align-items-center cursor-pointer
                                ${localValueArr.includes(answerArr.answer_id.toString()) ? "sf-ans-btn-selected " : " "}
    
                                ${props.showAnswerResponse && !props.showSubmitLoader && (tempSelectedAnswerArray !== undefined &&
                                    tempSelectedAnswerArray.includes(answerArr.answer_id.toString())) ? (props.answerCorrect ? "sf-ans-btn-correct " : "sf-ans-btn-incorrect ") : " "}
    
                                ${props.showAnswerResponse && !props.showSubmitLoader && answerArr.isChecked ? "sf-ans-btn-correct " : " "}
                            `}
                        >
                            {checkBox}
                            <label for={'checkBox' + cIndex} className='w-100 cursor-pointer p-0 m-0'>

                            {
                                  answerArr?.newVectorValues !== undefined && answerArr?.newVectorValues && answerArr?.newVectorValues.length > 0  && vectorSettingsData ? 

                                    <SFVectorAnswer
                                        vector={[...answerArr?.newVectorValues]}
                                        vectorSettingsData={vectorSettingsData}
                                    /> : ""
                                    
                                }
                            </label>
                                    
                        </div>

                    </Cell>
                );
            }
        }
        );

    }


    if (props.displayAnswerArr !== undefined && props.displayAnswerArr.length > 0)
        return <div>
                <div className='mb-2 text-secondary' tabIndex={0}>Select one or more from the below options:</div>
                <Grid>
                    {answerDisplayArray}
                </Grid>
        </div>
    else
        return <LoadingSpinner />
};

export default SFMCChecboxTypeAnswers;
